import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";

interface BadgeListProps extends ComponentPropsWithRef<"ul"> {
  content: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const BadgeList = forwardRef<HTMLUListElement, BadgeListProps>(
  ({ content, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles });

    return (
      <ul
        ref={ref}
        className={classNames(
          "wb-flex wb-list-none wb-flex-wrap wb-items-center wb-gap-2",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        {/* TODO: Implement li block */}
        {content}
      </ul>
    );
  },
);

BadgeList.displayName = "BadgeList";
